function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#3B82B9",
  d: "M125.8 1H4.2A3.2 3.2 0 001 4.2v121.6a3.2 3.2 0 003.2 3.2h121.6a3.2 3.2 0 003.2-3.2V4.2a3.2 3.2 0 00-3.2-3.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M88.368 35.471H43.245c-4.29 0-7.803 3.5-7.803 7.78v45.143c0 4.278 3.513 7.777 7.803 7.777h45.123c4.292 0 7.8-3.499 7.8-7.777V43.251c0-4.28-3.508-7.78-7.8-7.78zm-9.541 9.526a2.31 2.31 0 012.306-2.301h5.51a2.312 2.312 0 012.305 2.301v5.502a2.309 2.309 0 01-2.305 2.299h-5.51a2.307 2.307 0 01-2.306-2.299v-5.502zm-13.021 7.817c7.185 0 13.01 5.816 13.01 12.993 0 7.176-5.825 12.991-13.01 12.991-7.186 0-13.011-5.815-13.011-12.991 0-7.177 5.825-12.993 13.011-12.993zm24.622 35.157a2.412 2.412 0 01-2.413 2.406H43.663a2.414 2.414 0 01-2.413-2.406V61.463h6.257a18.823 18.823 0 00-.52 4.32c0 10.392 8.436 18.814 18.841 18.814 10.406 0 18.84-8.423 18.84-18.814 0-1.492-.211-2.929-.54-4.32h6.3v26.508z"
});

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
}

export default SvgInstagram;